import "../assets/preloader.css";
import resolveImageUrl from "../getImageUrl";

export default function Preloader({ src }) {
  return (
    <div className="preloader-wrapper">
      <div className="preloader-circle">
        <div className="preloader-spinner"></div>
        <img
          // src={src}
          src={resolveImageUrl("/assets/upload/images/template_image/logo-sampang.png")}
          alt="Kabupaten Sampang"
          className="preloader-logo"
        />
      </div>
      <p className="preloader-text">Memuat data, mohon tunggu...</p>
    </div>
  );
}